export default function RoomDirectory({ rooms, onSelect, onAdd, adding, notice }) {
  return (
    <section className="admin-room-directory" aria-labelledby="admin-room-directory-title">
      <div className="admin-room-directory-header">
        <div>
          <span className="eyebrow">ROOM MANAGEMENT</span>
          <h2 id="admin-room-directory-title">Rooms</h2>
        </div>
        <button className="button button-gold" type="button" onClick={onAdd} disabled={adding}>
          {adding ? 'Adding…' : 'Add room'}
        </button>
      </div>
      {notice && <p role="alert">{notice}</p>}
      {rooms.length ? (
        <div className="admin-room-directory-grid">
          {rooms.map((room) => (
            <button
              className="admin-room-directory-card"
              key={room.number}
              type="button"
              onClick={() => onSelect(room.number)}
            >
              <strong>Room {String(room.number).padStart(2, '0')}</strong>
              <span>{room.title}</span>
              {room.capacity && <span>Capacity: {room.capacity}</span>}
            </button>
          ))}
        </div>
      ) : (
        <p>No rooms have been added yet.</p>
      )}
    </section>
  );
}